import React, { Component } from 'react';  
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from '../NavigatorMain.js';
import Util from '../../util.js';
import { hashHistory } from 'react-router';
import { 
  smrzPassWord,
  smrzPassWordAgain
} from '../../action/investmentAction.js';
import { connect } from 'react-redux';

class CertificationSetPassWord extends Component {
	state = {
		passWord: this.props.smrzPassWord,
		passWordAgain: this.props.smrzPassWordAgain,
		enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
	}

	componentWillMount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
		document.getElementsByTagName('title')[0].innerHTML = "实名认证";
	}

	goCertification = () => {
		let { passWord, passWordAgain } = this.state;
		let { savePicFun, actualBeneficiaryCity, actualControllerCity, name, authRequestNo, bankAccountName, bankAccountShowNo, bankCode, businessType, certNo, certType, paymentChannelId, actualBeneficiary, actualController, actualBeneficiaryCertType, actualBeneficiaryCertNo, actualControllerCertType, actualControllerCertNo, officialsOrRelatives, address, careerCode, provinceCode, cityCode, mobileNo, annualIncomeV2,annualIncome,actualControllerBirthday,actualControllerValidTerm,actualControllerValidEver,actualControllerSex,actualControllerMobileNo,actualControllerProvince,actualControllerProfession,actualControllerAddress,actualControllerPostcode,actualControllerEmail,actualBeneficiaryValidTerm,actualBeneficiaryValidEver,actualBeneficiarySex,actualBeneficiaryBirthday,actualBeneficiaryMobileNo,actualBeneficiaryProvince,actualBeneficiaryAddress,actualBeneficiaryPostcode,actualBeneficiaryProfession,actualBeneficiaryEmail,conversationId,certLifeTime,certValidEver,certValidTerm } = this.props.location.state;
		let { userMobileNo } = this.props;
		let pattern = Util.passwordPattern;
		if(!pattern.test(passWord)){
			Toast.info( "密码必须是6至8位的字母或数字组合且不能完全重复", 2);
	      	return;
	    }
		if(passWordAgain != passWord) {
			Toast.info( "密码不一致，请重新输入", 2);
			return ;
		}
		if(passWordAgain.length < 6) {
			Toast.info( "确认密码至少6位数", 2);
			return ;
		}
		if(passWord.length < 6) {
			Toast.info( "密码至少6位数", 2);
			return ;
		}
		if(passWordAgain.length > 8) {
			Toast.info( "确认密码至多8位数", 2);
			return ;
		}
		if(passWord.length > 8) {
			Toast.info( "密码至多8位数", 2);
			return ;
		}
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
		hashHistory.push({
          pathname:"/TaxInfo",
          state:{
          	passWord:passWord,
          	name:name,
          	authRequestNo:authRequestNo,
          	bankAccountName:bankAccountName,
          	bankAccountShowNo:bankAccountShowNo,
          	bankCode:bankCode,
          	businessType:businessType,
          	certNo:certNo,
          	certType:certType,
          	mobileNo:mobileNo ? mobileNo : userMobileNo,
          	paymentChannelId:paymentChannelId,
          	actualBeneficiary: actualBeneficiary,
            actualController: actualController,
            actualBeneficiaryCertType: actualBeneficiaryCertType,
            actualBeneficiaryCertNo: actualBeneficiaryCertNo,
            actualControllerCertType: actualControllerCertType,
            actualControllerCertNo: actualControllerCertNo,
            officialsOrRelatives: officialsOrRelatives, 
          	address:address,
          	careerCode:careerCode,
          	cityCode:cityCode,
          	provinceCode:provinceCode,
			callback: callback,
			route: route,
			enterType:this.state.enterType,
			annualIncomeV2:annualIncomeV2,
            annualIncome:annualIncome,
            actualControllerBirthday: actualControllerBirthday,
            actualControllerValidTerm: actualControllerValidTerm,
            actualControllerValidEver: actualControllerValidEver,
            actualControllerSex: actualControllerSex,
            actualControllerMobileNo: actualControllerMobileNo,
            actualControllerProvince: actualControllerProvince,
            actualControllerProfession: actualControllerProfession,
            actualControllerAddress: actualControllerAddress,
            actualControllerPostcode: actualControllerPostcode,
            actualControllerEmail: actualControllerEmail,
            actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
            actualBeneficiaryValidEver: actualBeneficiaryValidEver,
            actualBeneficiarySex: actualBeneficiarySex,
            actualBeneficiaryBirthday: actualBeneficiaryBirthday,
            actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
            actualBeneficiaryProvince: actualBeneficiaryProvince,
            actualBeneficiaryAddress: actualBeneficiaryAddress,
            actualBeneficiaryPostcode: actualBeneficiaryPostcode,
            actualBeneficiaryProfession: actualBeneficiaryProfession,
            actualBeneficiaryEmail: actualBeneficiaryEmail,
			actualBeneficiaryCity: actualBeneficiaryCity,
			actualControllerCity: actualControllerCity,
			savePicFun: savePicFun,
            conversationId: conversationId,
			certLifeTime: certLifeTime,
			certValidEver: certValidEver,
			certValidTerm: certValidTerm,
          },
          query: {enterType:this.state.enterType,
						activityId:this.props.location.query.activityId}
        })
	}

	changePassWord = (event) => {
		let { dispatch } = this.props;
		this.setState({
			passWord :event.target.value
		})
		dispatch(smrzPassWord(event.target.value));
	}

	changePassWordAgain = (event) => {
		let { dispatch } = this.props;
		this.setState({
			passWordAgain :event.target.value
		})
		dispatch(smrzPassWordAgain(event.target.value));
	}

	goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
		hashHistory.goBack();
	}

	componentWillUnmount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
	}

	render() {
		let { passWord, passWordAgain } = this.state;
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div className="boxContent">
					<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
						<div style={{fontSize: "13px", color: "#5b6370"}}>请设置交易密码，在进行交易时使用，请妥善保管</div>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							交易密码
						</span>
						<input autocomplete="off"
						type="password"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}
						value={passWord}
						onChange={this.changePassWord}
						placeholder="请输入6-8位密码"
						/>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							确认密码
						</span>
						<input autocomplete="off"
						type="password"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}
						value={passWordAgain}
						onChange={this.changePassWordAgain}
						placeholder="请再次输入密码"
						/>
					</div>
					{
						passWordAgain != "" && passWord != "" ?
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#fa063a",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						onClick={this.goCertification}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div> :
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#afb0b2",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state,ownProps) {
  return {
    smrzPassWord: state.smrzPassWord,
    smrzPassWordAgain: state.smrzPassWordAgain,
    userMobileNo: state.userMobileNo
  }
}

export default connect(mapStateToProps)(CertificationSetPassWord);


// WEBPACK FOOTER //
// ./src/components/recommend/CertificationSetPassWord.js